import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";
import type { DisplayType } from "../../../../lib/types/enums/displayTypeEnum";

export type KeyMeRecentsProps = { displayType: DisplayType };

export const keyMeRecents: BaseKeyFunction<KeyMeRecentsProps> = ({
  displayType,
}) => ["me", "recents", { displayType }];
